import type { MediaToolOperation } from "@/features/media-tools";
import type { V2Capability } from "../types";
import { projectProductVariantCapability } from "./productCatalog";

/** Present admitted generation tools in the existing composer, retaining their
 * exact tool request identity instead of inventing a legacy model route. */
export function videoToolCapabilities(tools: MediaToolOperation[]): V2Capability[] {
  const generationOperations = ["text_to_video", "image_to_video", "first_last_frame", "reference_to_video", "multi_shot", "motion_transfer"];
  return tools.flatMap(tool => {
    if (tool.category !== "video" || !generationOperations.includes(tool.operation)) return [];
    const available = tool.variant_availability?.find(item => item.execution_available && item.quote_available);
    const variant = tool.product_variants.find(item => item.id === available?.product_variant_id);
    if (!variant || !available) return [];
    const capability: V2Capability = {
      product_model_id: tool.id, product_id: tool.product_id, kind: "model", media_type: "video", operation: tool.operation, operations: [tool.operation],
      readiness: "qualified", blocked_code: "", customer_available: true, test_only: false,
      qualification_scope: "none", qualified_configurations: [], surface_status: tool.surface_status, product_variants: [variant],
      max_outputs: variant.max_outputs, max_source_assets: 0, aspect_ratios: [], output_formats: [], requires_first_frame: false,
      minimum_credits_per_output: available.minimum_credits_per_output, maximum_credits_per_output: available.maximum_credits_per_output,
      prompt_supported: Boolean(variant.prompt), prompt_required: Boolean(variant.prompt?.required),
      media_tool: { id: tool.id, name: tool.name, variant_id: variant.id, execution_available: available.execution_available, quote_available: available.quote_available },
    };
    return [projectProductVariantCapability(capability, variant) ?? capability];
  });
}
